import { useTranslations } from "use-intl";

export default function useUtilTranslations() {
  return useTranslations("util");
}
